import React from "react";
import { CHANGE_BANDS } from "../StationPerformance.consts";

/**
 * What the colours in the change columns mean.
 *
 * Without this the bands are decoration. With it they are a scale, and a reader can tell the difference
 * between "worth a look" and "worth a phone call" without reading a single number.
 *
 * The free-charge note is not padding. Money falls to zero when a station stops charging for sessions,
 * so a red money cell on a station whose free share just jumped is a pricing change and not a decline: * the single most likely way to misread this table.
 */
const ChangeBandLegend: React.FC = () => (
  <div className="flex flex-column gap-2 mb-3">
    <div className="flex flex-wrap align-items-center gap-2">
      <span className="text-color-secondary text-sm mr-1">Change vs last month:</span>
      {CHANGE_BANDS.map((band) => (
        <span
          key={band.label}
          className="border-round px-2 py-1 text-sm"
          style={{ background: band.background, color: band.text }}
        >
          {band.label}
        </span>
      ))}
    </div>
    <span className="text-color-secondary text-sm">
      A red money cell on a station whose free share rose is a pricing change, not a decline — read the
      two columns together.
    </span>
  </div>
);

export default ChangeBandLegend;
